<template>
  <div class="opreate-decision">
    <div class="header-box">
      <div class="header-line">
        <el-button type="primary" size="small" @click="fetchDecisions">查询</el-button>
        <!-- <el-button type="primary" size="small" @click="onAddBtnClick">新增</el-button> -->
      </div>
    </div>
    <el-tabs v-model="activeTabName" @tab-click="handleTabChange">
      <el-tab-pane label="待处理" name="1"></el-tab-pane>
      <el-tab-pane label="已处理" name="2"></el-tab-pane>
      <el-tab-pane label="已忽略" name="3"></el-tab-pane>
      <el-tab-pane label="全部" name="100"></el-tab-pane>
    </el-tabs>
    <el-table :data="dataList" border size="small" :height="screenHeight" style="margin-top: 10px">
      <el-table-column label="序号" width="45px">
        <template slot-scope="scope">
          {{beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="产品名称"></el-table-column>
      <el-table-column prop="sku" label="SKU"></el-table-column>
      <el-table-column prop="ruleName" label="规则类型"></el-table-column>
      <el-table-column prop="ruleBusinessType" label="业务类型">
        <template slot-scope="scope">
          <div>{{ getRuleBusinessTypeLabel(scope.row.ruleBusinessType) }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="name" label="广告活动"></el-table-column>
      <el-table-column prop="name" label="广告组"></el-table-column> -->
      <el-table-column prop="keyword" label="关键词"></el-table-column>
      <el-table-column prop="ruleDescribe" label="规则说明" width="300px"></el-table-column>
      <el-table-column prop="describe" label="决策说明"></el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="executeDecision(scope.row)">执行</el-button>
          <el-button type="text" size="small" @click="ignoreDecision(scope.row)">忽略</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick">
    </el-pagination>
  </div>
</template>

<script>
import {
  requestModules
} from '@r'
export default {
  data() {
    return {
      total: 0,
      pageCount: 1,
      dataList: [],
      activeTabName: "1",
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      params: {
        state: 1,
        beginIndex: 0,
        pageSize: 50,
      },
    }
  },
  mounted() {
    this.fetchDecisions();
    this.$eventBus.$on('resize', this.calculateHeight)
  },
  beforeDestroy() {
    this.$eventBus.$off('resize', this.calculateHeight)
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68
    },
    handleTabChange(tab, event) {
      console.log(tab)
      this.fetchDecisions();
    },
    fetchDecisions() {
      this.params.state = this.activeTabName == 100 ? null : this.activeTabName;
      requestModules.fetchDecisions(this.params).then(res => {
        this.dataList = res.ldata;
        this.total = res.total;
      })
    },
    executeDecision(row) {
      requestModules.executeDecision({ id: row._id }).then(res => {
        this.$message({
          type: 'success',
          message: res.result == 1 ? "执行成功！" : "执行失败！"
        });
      })
    },
    ignoreDecision(row) {
      requestModules.ignoreDecision({ id: row._id }).then(res => {
        this.$message({
          type: 'success',
          message: res.result == 1 ? "执行成功！" : "执行失败！"
        });
      })
    },
    getRuleBusinessTypeLabel(ruleBusinessType) {
      let label = "";
      ruleBusinessType == 1 && (label = "精准关键词");
      ruleBusinessType == 2 && (label = "紧密匹配");
      ruleBusinessType == 3 && (label = "广泛匹配");
      ruleBusinessType == 4 && (label = "产品价格");
      return label;
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.fetchDecisions();
    },
  }
}
</script>

<style lang="scss">
.opreate-decision {
}
</style>
